let shopData = {
  categories: [
    {
      id: 1,
      name: "gryzaki",
      items: [
        {
          id: 11,
          name: "eco gryzak skórzany",
          price: 10,
          producer: "Animini",
          mainImg: "https://cf.shopee.pl/file/ae169f5d030b92a90e5e53992a04e8ab",
          carouselImgs: [
            "https://cf.shopee.pl/file/ae169f5d030b92a90e5e53992a04e8ab",
            "https://cf.shopee.pl/file/57020a53ce5be73c05560178a4563f64",
            "https://cf.shopee.pl/file/a873d77a44fdfa8d4f53801d48e03f3f",
          ],
          description: "To jest opis gryzaka",
          availability: "dostępny",
        },
        {
          id: 12,
          name: "poroże jelenia",
          price: 17,
          producer: "nat4dog",
          mainImg:
            "https://nat4dog.pl/userdata/public/gfx/1257/188cfd6d90775ade234ffd6a8f1624f3.jpg",
          carouselImgs: [
            "https://4dogsoriginal.com/wp-content/uploads/2021/04/gryzak-z-poroza-jelenia-rozmiar-S-hard-012_web.jpg",
            "https://4dogsoriginal.com/wp-content/uploads/2021/04/poroze-jelenia-dla-psa-rozmiar-M-hard-02.jpg",
            "https://4dogsoriginal.com/wp-content/uploads/2021/04/gryzak-z-poroza-jelenia_web2-1.jpg",
            "https://4dogsoriginal.com/wp-content/uploads/2021/04/infografika-zalety-porozejelenia-hard.jpg",
          ],
          description: "Poroże ze zrzutu jelenia jako gryzak dla psa",
          availability: "dostępny",
        },
      ],
    },
    {
      id: 2,
      name: "przysmaki",
      items: [
        {
          id: 21,
          name: "eco przysmak zielony",
          price: 21,
          producer: "Animini",
          mainImg:
            "https://image.ceneostatic.pl/data/products/53075392/i-chico-przysmak-kabanosy-zielone-kielbaski-100szt.jpg",
          carouselImgs: [
            "https://cf.shopee.pl/file/ae169f5d030b92a90e5e53992a04e8ab",
            "https://cf.shopee.pl/file/57020a53ce5be73c05560178a4563f64",
            "https://cf.shopee.pl/file/a873d77a44fdfa8d4f53801d48e03f3f",
          ],
          description: "To jest opis przysmaku",
          availability: "dostępny",
        },
      ],
    },
    {
      id: 3,
      name: "suplementy",
      items: [
        {
          id: 31,
          name: "suplement na stawy",
          price: 34,
          producer: "Doggy",
          mainImg:
            "https://fish4dogspolska.pl/wp-content/uploads/2020/05/suplement-diety-dla-psa-fish4dogs-stawy.jpg",
          carouselImgs: [
            "https://cf.shopee.pl/file/ae169f5d030b92a90e5e53992a04e8ab",
            "https://cf.shopee.pl/file/57020a53ce5be73c05560178a4563f64",
            "https://cf.shopee.pl/file/a873d77a44fdfa8d4f53801d48e03f3f",
          ],
          description: "To jest opis przysmaku",
          availability: "dostępny",
        },
      ],
    },
    {
      id: 4,
      name: "kosmetyki",
      items: [
        {
          id: 41,
          name: "eco kosmetyk do psa",
          price: 97,
          producer: "PetLi",
          mainImg:
            "https://megazoologiczny.pl/pol_pm_Over-zoo-silk-spray-250ml-19145_1.png",
          carouselImgs: [
            "https://cf.shopee.pl/file/ae169f5d030b92a90e5e53992a04e8ab",
            "https://cf.shopee.pl/file/57020a53ce5be73c05560178a4563f64",
            "https://cf.shopee.pl/file/a873d77a44fdfa8d4f53801d48e03f3f",
          ],
          description: "To jest opis kosmetyku do głowy dla psa",
          availability: "dostępny",
        },
      ],
    },
    {
      id: 5,
      name: "akcesoria",
      items: [
        {
          id: 51,
          name: "kaganiec super eco",
          price: 125,
          producer: "Choppy",
          mainImg:
            "https://groomershop.pl/media/catalog/product/thumbnail/64bd19accd0b8c98a3b672933bf160cf/image/0/500x500/111/80/0/6/06d5264ce22d4ad6edccfbcad9459fb9_7.jpg",
          carouselImgs: [
            "https://cf.shopee.pl/file/ae169f5d030b92a90e5e53992a04e8ab",
            "https://cf.shopee.pl/file/57020a53ce5be73c05560178a4563f64",
            "https://cf.shopee.pl/file/a873d77a44fdfa8d4f53801d48e03f3f",
          ],
          description: "To jest opis akcesorium dla psa",
          availability: "na zamówienie",
        },
        {
          id: 52,
          name: "obroża eco",
          price: 150,
          producer: "Choppy",
          mainImg:
            "https://4wild.eu/userdata/public/gfx/139/3d2fe21e93c4a58bf9f5060849f30767.jpg",
          carouselImgs: [
            "https://4wild.eu/userdata/public/gfx/139/3d2fe21e93c4a58bf9f5060849f30767.jpg",
            "https://4wild.eu/userdata/public/gfx/140/1beb0b272b67cc7160f3952710ad0793.jpg",
            "https://4wild.eu/userdata/public/gfx/141/0822b385317c2625e78aca7403389919.jpg",
          ],
          description: "To jest opis akcesorium dla psa",
          availability: "dostępny",
        },
      ],
    },
  ],
};

export default shopData;
